import React, { useState } from 'react';
import AuthorsAddScreen from './AuthorsAddScreen';
import { useModal } from '../../common/context/ModalProvider';
import Screen from '../../components/layout/Screen';
import { ICONS } from '../../common/icons/icons';
import Animated from '../../components/AnimatedComponent';
import { ListApiInfinite } from '../../components/List';
import AuthorsService from '../../common/API/AuthorsService';
import SectionTitle from '../../components/SectionTitle';
import useForceRefetch from '../../common/hooks/useForceRefetch';
import { useDialog } from './../../common/hooks/useDialog';
import AuthorsEditScreen from './AuthorsEditScreen';
import { GoTrash } from 'react-icons/go';
import { Button } from '@/components/ui/button';
import { Link, useNavigate } from 'react-router-dom';
import Toast from '@/common/Toast';

const AuthorsListScreen = () => {
  const [search, setSearch] = useState('');
  const { shouldRefetch, forceRefetch } = useForceRefetch();
  const { showConfirmDialog, hideConfirmDialog, openDrawer, closeDrawer } = useDialog();
  const navigate = useNavigate();
  const onDelete = (id: number) => {
    showConfirmDialog({
      title: 'Delete item',
      description: 'Are you sure you want to delete this item?',
      buttons: [
        {
          title: 'Confirm',
          onClick: () => {
            AuthorsService.delete(id).then((res: any) => {
              Toast.success(res?.message);
              forceRefetch();
              hideConfirmDialog();
            });
          },
          color: 'primary',
        },
        {
          title: 'Cancel',
          color: 'neutral',
          variant: 'link',
          closesModal: true,
        },
      ],
    });
  };

  return (
    <Screen
      screenContainerClassName='bg-black'
      screenOptions={{
        header: {
          title: 'Authors',
          backBtnLabel: 'Home',
          backBtnUrl: '/home',
          rightContent: (
            <Button
              variant='ghost'
              size='icon'
              onClick={() => {
                navigate('/authors/add');
              }}
            >
              {ICONS.plus}
            </Button>
          ),
        },
      }}
    >
      <ListApiInfinite<any>
        onSearch={setSearch}
        queryKey={['authors', search, shouldRefetch]}
        queryFn={({ pageParam }) =>
          AuthorsService.all({
            page: pageParam,
            search,
            per_page: 20,
          })
        }
        containerClassName='h-full px-4'
        renderItem={(item, i) => {
          return (
            <div className='grid grid-cols-5 w-full' key={item.id}>
              <Link to={`/authors/${item.id}`} className='col-span-4 p-4 '>
                <span className='text-xs text-white/40 block mb-1'>Author</span>
                {item?.name}
              </Link>
              <div className='col-span-1 p-4 flex items-center justify-center' onClick={() => onDelete(item.id)}>
                <GoTrash />
              </div>
            </div>
          );
        }}
        header={
          <section>
            <div className='mb-1'>
              <SectionTitle label='Authors' className='text-white' />
              <p className='text-white/50'>Someone had to come up with all those clever quotes.</p>
            </div>
            <div className='w-full overflow-hidden flex items-center justify-center'>
              <div className='min-w-[150vw] flex items-center justify-center'>
                <img src='assets/images/author.png' className='h-[200px] w-auto' alt='' />
              </div>
            </div>
          </section>
        }
      />
    </Screen>
  );
};

export default AuthorsListScreen;
